import { useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const useEnvase = () => {
  const [envase, setEnvase] = useState([]);
  const getEnvase = async () => {
    try {
      const response = await api.get("api/etiquetas/obt/tamano-envase");
      console.log(response.data);
      setEnvase(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getEnvase();
  }, []);

  return { envase };
};
